import { Component, Prop, h } from '@stencil/core';
import Icon from '../svg/caret-right.svg'
@Component({
  tag: 'cr-caret-right',
  styleUrl: '../cr-icon.css',
  shadow: true,
})
export class CrCaretRight {
  /**
    * The size of the icon - can be 'small', 'medium' or 'large'
    */
  @Prop() size: string
  @Prop() disabled: boolean

  render() {

    return (
      <div
        part="cr-icon"
        class={`${this.size} ${this.disabled ? 'disabled' : ''}`}
        innerHTML={Icon}
      />
    );
  }

}
